// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jzon from "rescript-jzon/lib/es6/src/Jzon.res.js";
import * as LumiSVG from "lumi-rescript/lib/es6/src/LumiSVG.res.js";
import * as LumiJzon from "lumi-rescript/lib/es6/src/LumiJzon.res.js";
import * as LumiReact from "lumi-rescript/lib/es6/src/LumiReact.res.js";
import * as V2f$Linear from "lumi-linear/lib/es6/src/V2f.res.js";
import * as StringCodec from "lumi-rescript/lib/es6/src/StringCodec.res.js";
import * as Stdlib_Result from "@rescript/runtime/lib/es6/Stdlib_Result.js";
import * as Transform$Linear from "lumi-linear/lib/es6/src/Transform.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as BoundingBox$Linear from "lumi-linear/lib/es6/src/BoundingBox.res.js";
import * as NNRoi$LumiDocuments from "./NNRoi.res.js";
import * as Translation$LumiI18n from "lumi-i18n/lib/es6/src/Translation.res.js";
import * as AxesModel$LumiDocuments from "./AxesModel.res.js";
import * as StapleModel$LumiDocuments from "./StapleModel.res.js";
import * as QuadrilateralModel$LumiDocuments from "./QuadrilateralModel.res.js";

import '../../../src/css/place-model.scss'
;

function axesToQuadrilateralModel(param) {
  let baseBack = param.baseBack;
  let baseFront = param.baseFront;
  let sf = V2f$Linear.minus(baseFront, param.side);
  return {
    a: V2f$Linear.minus(baseFront, sf),
    b: V2f$Linear.plus(baseFront, sf),
    c: V2f$Linear.plus(baseBack, sf),
    d: V2f$Linear.minus(baseBack, sf),
    up: param.up,
    width: param.sideLength * 2
  };
}

let options = [
  "AxesPlaceModel",
  "QuadrilateralPlaceModel",
  "StaplePlaceModel"
];

let stringCodec = StringCodec.anySumAsString(options, undefined);

let jsonCodec = LumiJzon.stringCodec(stringCodec);

function translate(locale, entry) {
  switch (locale) {
    case "DEU" :
      switch (entry) {
        case "AxesPlaceModel" :
          return "Achsen-Platzmodell";
        case "QuadrilateralPlaceModel" :
          return "Viereck-Platzmodell";
        case "StaplePlaceModel" :
          return "Klammer-Platzmodell";
      }
    case "ENG" :
      switch (entry) {
        case "AxesPlaceModel" :
          return "Axes place model";
        case "QuadrilateralPlaceModel" :
          return "Quadrilateral place model";
        case "StaplePlaceModel" :
          return "Staple place model";
      }
    case "FRA" :
      switch (entry) {
        case "AxesPlaceModel" :
          return "Modèle de endroit a axe";
        case "QuadrilateralPlaceModel" :
          return "Modèle de endroit quadrilatère";
        case "StaplePlaceModel" :
          return "Modèle de endroit agrafe";
      }
    case "NLD" :
      switch (entry) {
        case "AxesPlaceModel" :
          return "Assen plaatsmodel";
        case "QuadrilateralPlaceModel" :
          return "Vierhoek plaatsmodel";
        case "StaplePlaceModel" :
          return "Nietjes plaatsmodel";
      }
    default:
      return;
  }
}

let T = Translation$LumiI18n.MakeProvider({
  defaultLocale: "ENG",
  translate: translate
});

let Enum = {
  options: options,
  stringCodec: stringCodec,
  jsonCodec: jsonCodec,
  T: T
};

function toEnum(pm) {
  switch (pm.TAG) {
    case "AxesPlaceModel" :
      return "AxesPlaceModel";
    case "QuadrilateralPlaceModel" :
      return "QuadrilateralPlaceModel";
    case "StaplePlaceModel" :
      return "StaplePlaceModel";
  }
}

function axesPlaceModel(am) {
  return {
    TAG: "AxesPlaceModel",
    _0: am
  };
}

function quadrilateralPlaceModel(qm) {
  return {
    TAG: "QuadrilateralPlaceModel",
    _0: qm
  };
}

function staplePlaceModel(sm) {
  return {
    TAG: "StaplePlaceModel",
    _0: sm
  };
}

let jsonCodec$1 = LumiJzon.taggedVariant(placeModel => {
  switch (placeModel.TAG) {
    case "AxesPlaceModel" :
      return [
        "AxesPlaceModel",
        Jzon.encodeWith(placeModel._0, AxesModel$LumiDocuments.jsonCodec)
      ];
    case "QuadrilateralPlaceModel" :
      return [
        "QuadrilateralPlaceModel",
        Jzon.encodeWith(placeModel._0, QuadrilateralModel$LumiDocuments.jsonCodec)
      ];
    case "StaplePlaceModel" :
      return [
        "StaplePlaceModel",
        Jzon.encodeWith(placeModel._0, StapleModel$LumiDocuments.jsonCodec)
      ];
  }
}, param => {
  let json = param[1];
  let tag = param[0];
  switch (tag) {
    case "AxesPlaceModel" :
      return Stdlib_Result.map(Jzon.decodeWith(json, AxesModel$LumiDocuments.jsonCodec), axesPlaceModel);
    case "QuadrilateralPlaceModel" :
      return Stdlib_Result.map(Jzon.decodeWith(json, QuadrilateralModel$LumiDocuments.jsonCodec), quadrilateralPlaceModel);
    case "StaplePlaceModel" :
      return Stdlib_Result.map(Jzon.decodeWith(json, StapleModel$LumiDocuments.jsonCodec), staplePlaceModel);
    default:
      return {
        TAG: "Error",
        _0: {
          NAME: "UnexpectedJsonValue",
          VAL: [
            [],
            tag
          ]
        }
      };
  }
}, undefined, undefined);

function up(pm, placeClass) {
  switch (pm.TAG) {
    case "AxesPlaceModel" :
      return AxesModel$LumiDocuments.up(pm._0, placeClass);
    case "QuadrilateralPlaceModel" :
      return pm._0.up;
    case "StaplePlaceModel" :
      return AxesModel$LumiDocuments.up(pm._0.axes, placeClass);
  }
}

function transform(placeModelSpaceSize, hmirror, vflip, placeModel) {
  switch (placeModel.TAG) {
    case "AxesPlaceModel" :
      return {
        TAG: "AxesPlaceModel",
        _0: AxesModel$LumiDocuments.transform(placeModelSpaceSize, hmirror, vflip, placeModel._0)
      };
    case "QuadrilateralPlaceModel" :
      return {
        TAG: "QuadrilateralPlaceModel",
        _0: QuadrilateralModel$LumiDocuments.transform(placeModelSpaceSize, hmirror, vflip, placeModel._0)
      };
    case "StaplePlaceModel" :
      return {
        TAG: "StaplePlaceModel",
        _0: StapleModel$LumiDocuments.transform(placeModelSpaceSize, hmirror, vflip, placeModel._0)
      };
  }
}

function warpAffine(placeModel, m23) {
  switch (placeModel.TAG) {
    case "AxesPlaceModel" :
      return {
        TAG: "AxesPlaceModel",
        _0: AxesModel$LumiDocuments.warpAffine(placeModel._0, m23)
      };
    case "QuadrilateralPlaceModel" :
      return {
        TAG: "QuadrilateralPlaceModel",
        _0: QuadrilateralModel$LumiDocuments.warpAffine(placeModel._0, m23)
      };
    case "StaplePlaceModel" :
      return {
        TAG: "StaplePlaceModel",
        _0: StapleModel$LumiDocuments.warpAffine(placeModel._0, m23)
      };
  }
}

function toPoly(placeModel, placeClass) {
  switch (placeModel.TAG) {
    case "AxesPlaceModel" :
      return AxesModel$LumiDocuments.toPoly(placeModel._0, placeClass);
    case "QuadrilateralPlaceModel" :
      return QuadrilateralModel$LumiDocuments.toPoly(placeModel._0, placeClass);
    case "StaplePlaceModel" :
      return StapleModel$LumiDocuments.toPoly(placeModel._0, placeClass);
  }
}

function extraPoints(placeModel) {
  switch (placeModel.TAG) {
    case "AxesPlaceModel" :
      return AxesModel$LumiDocuments.extraPoints(placeModel._0);
    case "QuadrilateralPlaceModel" :
      return QuadrilateralModel$LumiDocuments.extraPoints(placeModel._0);
    case "StaplePlaceModel" :
      return StapleModel$LumiDocuments.extraPoints(placeModel._0);
  }
}

function boundingBox(placeModel, placeClass) {
  return BoundingBox$Linear.axisAlignedBoundingBox(NNRoi$LumiDocuments.NNPolygon.points(toPoly(placeModel, placeClass)).concat(extraPoints(placeModel)));
}

function mainPoint(placeModel) {
  switch (placeModel.TAG) {
    case "AxesPlaceModel" :
      return AxesModel$LumiDocuments.mainPoint(placeModel._0);
    case "QuadrilateralPlaceModel" :
      return QuadrilateralModel$LumiDocuments.mainPoint(placeModel._0);
    case "StaplePlaceModel" :
      return StapleModel$LumiDocuments.mainPoint(placeModel._0);
  }
}

let $$default = [
  800,
  600
];

let include = LumiReact.Context.Make({
  $$default: $$default
});

let useContext = include.useContext;

let SpaceSize_context = include.context;

let SpaceSize_Provider = include.Provider;

let SpaceSize = {
  $$default: $$default,
  context: SpaceSize_context,
  useContext: useContext,
  Provider: SpaceSize_Provider
};

function PlaceModel$Svg$Circle(props) {
  let __classList = props.classList;
  let classList = __classList !== undefined ? __classList : [];
  let placeModelSpaceSize = useContext();
  let className = LumiReact.classList([[
      "place-model-circle",
      true
    ]].concat(classList));
  let match = V2f$Linear.mapToString(props.mainPoint);
  let x = V2f$Linear.length(placeModelSpaceSize);
  let r = (x / 100).toString();
  return JsxRuntime.jsx("circle", {
    className: className,
    cx: match[0],
    cy: match[1],
    r: r,
    vectorEffect: "non-scaling-stroke"
  });
}

let Circle = {
  make: PlaceModel$Svg$Circle
};

function PlaceModel$Svg$Label(props) {
  let __classList = props.classList;
  let classList = __classList !== undefined ? __classList : [];
  let placeModelSpaceSize = useContext();
  let className = LumiReact.classList([
    [
      "place-model-label",
      true
    ],
    [
      "is-family-monospace",
      true
    ],
    [
      "is-unselectable",
      true
    ]
  ].concat(classList));
  let match = V2f$Linear.mapToString(props.mainPoint);
  let x = V2f$Linear.length(placeModelSpaceSize);
  let fontSize = (x / 150 | 0).toString();
  return JsxRuntime.jsx("text", {
    children: props.label,
    className: className,
    dominantBaseline: "central",
    fontSize: fontSize,
    textAnchor: "middle",
    x: match[0],
    y: match[1]
  });
}

let Label = {
  make: PlaceModel$Svg$Label
};

function PlaceModel$Svg$Base(props) {
  let __classList = props.classList;
  let placeModel = props.placeModel;
  let classList = __classList !== undefined ? __classList : [];
  let classList$1 = [[
      "place-model",
      true
    ]].concat(classList);
  switch (placeModel.TAG) {
    case "AxesPlaceModel" :
      let match = placeModel._0;
      return JsxRuntime.jsx(AxesModel$LumiDocuments.Svg.Base.make, {
        baseFront: match.baseFront,
        baseBack: match.baseBack,
        classList: classList$1
      });
    case "QuadrilateralPlaceModel" :
      let match$1 = placeModel._0;
      return JsxRuntime.jsx(QuadrilateralModel$LumiDocuments.Svg.Contour.make, {
        points: [
          match$1.a,
          match$1.b,
          match$1.c,
          match$1.d
        ],
        classList: classList$1
      });
    case "StaplePlaceModel" :
      let match$2 = StapleModel$LumiDocuments.toAxesModel(placeModel._0);
      return JsxRuntime.jsx(AxesModel$LumiDocuments.Svg.Base.make, {
        baseFront: match$2.baseFront,
        baseBack: match$2.baseBack,
        classList: classList$1
      });
  }
}

let Base = {
  make: PlaceModel$Svg$Base
};

function PlaceModel$Svg(props) {
  let __labelClassList = props.labelClassList;
  let __circleClassList = props.circleClassList;
  let __upClassList = props.upClassList;
  let __sideClassList = props.sideClassList;
  let __baseClassList = props.baseClassList;
  let __classList = props.classList;
  let __parentTransform = props.parentTransform;
  let placeModel = props.placeModel;
  let parentTransform = __parentTransform !== undefined ? __parentTransform : Transform$Linear.M23f.identity;
  let classList = __classList !== undefined ? __classList : [];
  let baseClassList = __baseClassList !== undefined ? __baseClassList : [];
  let sideClassList = __sideClassList !== undefined ? __sideClassList : [];
  let upClassList = __upClassList !== undefined ? __upClassList : [];
  let circleClassList = __circleClassList !== undefined ? __circleClassList : [];
  let labelClassList = __labelClassList !== undefined ? __labelClassList : [];
  let classList$1 = [[
      "place-model",
      true
    ]].concat(classList);
  let mainPoint$1 = mainPoint(placeModel);
  let parentRotation = Transform$Linear.M23f.toSimpleTransform(parentTransform).rotate;
  let nonRotatedLabel = Transform$Linear.M23f.rotationAround(- parentRotation, mainPoint$1);
  let tmp;
  switch (placeModel.TAG) {
    case "AxesPlaceModel" :
      tmp = JsxRuntime.jsx(AxesModel$LumiDocuments.Svg.make, {
        axesModel: placeModel._0,
        baseClassList: baseClassList,
        sideClassList: sideClassList,
        upClassList: upClassList
      });
      break;
    case "QuadrilateralPlaceModel" :
      tmp = JsxRuntime.jsx(QuadrilateralModel$LumiDocuments.Svg.make, {
        quadModel: placeModel._0,
        baseClassList: baseClassList,
        sideClassList: sideClassList,
        upClassList: upClassList
      });
      break;
    case "StaplePlaceModel" :
      tmp = JsxRuntime.jsx(StapleModel$LumiDocuments.Svg.make, {
        stapleModel: placeModel._0,
        baseClassList: baseClassList,
        sideClassList: sideClassList,
        upClassList: upClassList
      });
      break;
  }
  return JsxRuntime.jsxs("g", {
    children: [
      tmp,
      JsxRuntime.jsx(PlaceModel$Svg$Circle, {
        mainPoint: mainPoint$1,
        classList: circleClassList
      }),
      LumiReact.renderOption(undefined, props.label, label => JsxRuntime.jsx("g", {
        children: JsxRuntime.jsx(PlaceModel$Svg$Label, {
          mainPoint: mainPoint$1,
          classList: labelClassList,
          label: label
        }),
        transform: LumiSVG.Transform.Matrix.fromM23f(nonRotatedLabel)
      }))
    ],
    className: LumiReact.classList(classList$1),
    onClick: props.onClick
  });
}

let Svg = {
  SpaceSize: SpaceSize,
  Circle: Circle,
  Label: Label,
  Base: Base,
  make: PlaceModel$Svg
};

export {
  axesToQuadrilateralModel,
  Enum,
  toEnum,
  axesPlaceModel,
  quadrilateralPlaceModel,
  staplePlaceModel,
  jsonCodec$1 as jsonCodec,
  up,
  transform,
  warpAffine,
  toPoly,
  extraPoints,
  boundingBox,
  mainPoint,
  Svg,
}
/*  Not a pure module */
